// Centralized rally cross-selling ticket types

const ticketTypesRallyCrossSelling = {
    eventGroupId: 3553,
    items: [
        {
            id: 1,
            price: 60.00,
            oldPrice: 75.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: false,
            externalTicketCode: "city rally regular tour",
            info: {
                name: {
                    de: "Teamticket Regular Tour (3-5 Personen)",
                    fr: "TEAMTICKET REGULAR TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Regular Tour (3 - 5 people)",
                    it: "Team ticket Regular Tour (3 - 5 people)",
                }
            },
        },
        {
            id: 2,
            price: 41.60,
            oldPrice: 52.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: false,
            externalTicketCode: "city rally shortcut tour",
            info: {
                name: {
                    de: "Teamticket Shortcut Tour (3-5 Personen)",
                    fr: "TEAMTICKET SHORTCUT TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Shortcut Tour (3 - 5 people)",
                    it: "Team ticket Shortcut Tour (3 - 5 people)"
                }
            },
        },
        /*  Stand alone page ticket types*/
        {
            id: 3,
            price: 75.00,
            oldPrice: 0.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: true,
            externalTicketCode: "city rally regular tour standalone",
            info: {
                name: {
                    de: "Teamticket Regular Tour (3-5 Personen)",
                    fr: "TEAMTICKET REGULAR TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Regular Tour (3 - 5 people)",
                    it: "Team ticket Regular Tour (3 - 5 people)",
                }
            },
        },
        {
            id: 4,
            price: 52.00,
            oldPrice: 0.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: true,
            externalTicketCode: "city rally shortcut tour standalone",
            info: {
                name: {
                    de: "Teamticket Shortcut Tour (3-5 Personen)",
                    fr: "TEAMTICKET SHORTCUT TOUR (Équipe: 3-5 personnes)",
                    en: "Team ticket Shortcut Tour (3 - 5 people)",
                    it: "Team ticket Shortcut Tour (3 - 5 people)"
                }
            },
        },
        {
            id: 5,
            price: 62.00,
            oldPrice: 0.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: true,
            externalTicketCode: "city rally posing tour standalone",
            info: {
                name: {
                    de: "Teamticket Posing Tour (3-5 Personen)",
                    fr: "Teamticket Posing Tour (3-5 Personen)",
                    en: "Teamticket Posing Tour (3-5 Personen)",
                    it: "Teamticket Posing Tour (3-5 Personen)"
                }
            },
        },
        {
            id: 6,
            price: 83.00,
            oldPrice: 0.00,
            currency: "CHF",
            quantity: 12,
            isStandAloneOnly: true,
            externalTicketCode: "city rally birthday rally standalone",
            info: {
                name: {
                    de: "Teamticket Birthday Tour (3-5 Personen)",
                    fr: "Teamticket Birthday Tour (3-5 Personen)",
                    en: "Teamticket Birthday Tour (3-5 Personen)",
                    it: "Teamticket Birthday Tour (3-5 Personen)"
                }
            },
        }
    ]
};

export default ticketTypesRallyCrossSelling;
